import React from "react";

export const PersonSearch = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z"
        fill="#008AFF"
      />
      <path
        d="M10.35 14.01C7.62 13.91 2 15.27 2 18V19C2 19.55 2.45 20 3 20H11.54C9.07 17.24 10.31 14.11 10.35 14.01ZM19.43 18.02C19.9 17.22 20.13 16.25 19.91 15.2C19.57 13.56 18.19 12.25 16.53 12.04C13.9 11.7 11.68 13.91 12.03 16.54C12.25 18.2 13.55 19.58 15.19 19.92C16.24 20.14 17.21 19.91 18.01 19.44L19.87 21.3C20.057 21.487 20.3106 21.5921 20.575 21.5921C20.8394 21.5921 21.093 21.487 21.28 21.3C21.467 21.1131 21.572 20.8595 21.572 20.595C21.572 20.3306 21.467 20.077 21.28 19.89L19.43 18.02ZM16 18C14.9 18 14 17.1 14 16C14 14.9 14.9 14 16 14C17.1 14 18 14.9 18 16C18 17.1 17.1 18 16 18Z"
        fill="#4BCFFF"
      />
    </svg>
  );
};
